var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SectorType } from "../../../models/sector/sector.model";
import { useReadOnly } from "../../../utils/hooks/users/useReadOnly";
import { thinScrollbarSx } from "../../../utils/scrollbar.util";
import OtherGuests from "../guests/OtherGuests";
import ProfilePastVisits from "../pastVisits/ProfilePastVisits";
import SectorPastVisits from "../pastVisits/SectorPastVisits";
import ContactCard from "./ContactCard";
import PersonalCard from "./PersonalCard";
import ProfileHeader from "./ProfileHeader";
import { SidebarCardsProvider } from "./SidebarCard";
import StayCard from "./StayCard";
var ProfileSidebar = function (_a) {
    var profile = _a.profile, onProfileChange = _a.onProfileChange, mode = _a.mode, sector = _a.sector, voiceNoteId = _a.voiceNoteId, reservationId = _a.reservationId, otherGuests = _a.otherGuests, bookingDetails = _a.bookingDetails, onOpenFullProfile = _a.onOpenFullProfile, onBackToReservation = _a.onBackToReservation, onRemoveFromReservation = _a.onRemoveFromReservation;
    var t = useTranslation().t;
    var readOnly = useReadOnly();
    return (_jsx(SidebarCardsProvider, { children: _jsxs(Stack, __assign({ sx: __assign({ width: '100%', gap: '16px', padding: '16px 16px', '@media (min-width:768px)': {
                    width: mode === 'full' ? '360px' : '100%',
                    flexShrink: 0
                } }, (mode === 'full' && __assign({ overflowY: { xs: 'visible', md: 'auto' } }, thinScrollbarSx))) }, { children: [mode === 'full' && onBackToReservation && (_jsx(Button, __assign({ startIcon: _jsx(ArrowBackIcon, { fontSize: 'small' }), onClick: onBackToReservation, sx: {
                        flexShrink: 0,
                        height: 44,
                        mx: '-16px',
                        mt: '-16px',
                        px: 2,
                        justifyContent: 'flex-start',
                        borderRadius: 0,
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        bgcolor: 'background.paper',
                        color: 'text.primary',
                        fontSize: 14,
                        textTransform: 'none',
                        position: { md: 'sticky' },
                        top: { md: '-16px' },
                        zIndex: 2,
                        '&:hover': { bgcolor: 'grey.50' }
                    } }, { children: _jsx(Box, __assign({ component: 'span', sx: { display: 'inline-block', mt: '2px', lineHeight: 1 } }, { children: t('Back to reservation') })) }))), bookingDetails, _jsx(ProfileHeader, { profile: profile, mode: mode, onOpenFull: onOpenFullProfile, onRemove: readOnly ? undefined : onRemoveFromReservation }), _jsx(StayCard, { profile: profile }), _jsx(PersonalCard, { profile: profile, setProfile: onProfileChange, voiceNoteId: voiceNoteId }), _jsx(ContactCard, { profile: profile, setProfile: onProfileChange }), profile.id && !sector && _jsx(ProfilePastVisits, { profile: profile }, profile.id), profile.id && sector && (sector.sectorType === SectorType.SPA || sector.sectorType === SectorType.RESTAURANT) && (_jsx(SectorPastVisits, { sector: sector, profile: profile, reservationId: reservationId }, profile.id)), mode === 'simple' && otherGuests && _jsx(OtherGuests, __assign({}, otherGuests))] })) }));
};
export default ProfileSidebar;
